import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api";
import { handleResponseError } from '../../../utils/helpers/network-error';

export const createExpense = createAsyncThunk('expenses.create', async ({
  formData, onSuccess, onFailure
}, { rejectWithValue }) => {
  try {
    const { data: { newExpense, message }} = await api.expenses.create(formData);
    onSuccess(message);
    return newExpense;
  } catch (error) {
    handleResponseError(error, onFailure);
    return rejectWithValue();
  }
});

export const updateExpense = createAsyncThunk('expenses.update', async ({
  formData, onSuccess, onFailure
}, { rejectWithValue }) => {
  try {
    const { _id, ...rest } = formData;

    const formDataWithoutEmptyFields = Object.keys(rest).reduce((acc, key) => {
      if (rest[key]) {
        acc[key] = rest[key];
      }
      return acc;
    }, {});

    const { data: { updatedExpense, message }} = await api.expenses.update(_id, formDataWithoutEmptyFields);
    onSuccess(message);
    return updatedExpense;
  } catch (error) {
    handleResponseError(error, onFailure);
    return rejectWithValue();
  }
});

export const getExpenses = createAsyncThunk('expenses.get', async ({
  page, limit, search, userIds, dateRange
}, { rejectWithValue }) => {
  try {
    const queryParams = {
      page,
      limit,
    };

    if (search && search.trim().length > 0) {
      queryParams.search = search.trim();
    }
    
    if (dateRange) {
      queryParams.startDate = dateRange.startDate;
      queryParams.endDate = dateRange.endDate;
    }

    const { data: { expenses, totalDocs }} = await api.expenses.getExpenses(queryParams);
    
    return {
      expenses,
      totalDocs,
    };
  } catch (error) {
    handleResponseError(error);
    return rejectWithValue();
  }
});

export const deleteExpenses = createAsyncThunk('expenses.deleteExpenses', async ({
  ids, onSuccess, onFailure
}, { rejectWithValue }) => {
  try {
    const { data: { message }} = await api.expenses.deleteExpenses(ids);
    onSuccess(message);
    return ids;
  } catch (error) {
    handleResponseError(error, onFailure);
    return rejectWithValue();
  }
});
